import React from 'react';
import { useInView } from '../../hooks';

const AboutSection = () => {
  const [ref, isInView] = useInView(0.1);

  return (
    <section id="about" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div
          ref={ref}
          className={`grid lg:grid-cols-2 gap-16 items-center transition-all duration-1000 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div>
            <p className="section-subtitle text-primary-500">OUR STORY</p>
            <h2 className="section-title">
              FORGING <span className="text-gradient">AFRICAN</span> LEGENDS
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              Born in the vibrant streets of Dar es Salaam, Riven Byte emerged
              from a shared dream: to bring African stories, cultures, and
              adventures to the global gaming stage. We believe every Tanzanian
              child deserves to see heroes who look like them, speak their
              languages, and honor their heritage.
            </p>
            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              From the majestic Kilimanjaro to the mystical Zanzibar coasts, from
              ancient Maasai legends to Swahili coastal tales — we transform our
              rich heritage into immersive digital experiences that resonate with
              gamers worldwide.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                <div className="text-3xl mb-2">🇹🇿</div>
                <h4 className="font-bold text-lg mb-1">Tanzanian Roots</h4>
                <p className="text-gray-500 text-sm">
                  Proudly headquartered in Dar es Salaam
                </p>
              </div>
              <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                <div className="text-3xl mb-2">🌍</div>
                <h4 className="font-bold text-lg mb-1">Global Reach</h4>
                <p className="text-gray-500 text-sm">
                  Players across 50+ countries
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-3xl bg-gradient-to-br from-primary-500/20 to-secondary-400/20 p-8 border border-white/10 relative overflow-hidden">
              <div className="absolute inset-0 african-pattern opacity-30" />
              <div className="relative z-10 h-full flex items-center justify-center">
                <div className="text-center">
                  <div className="w-32 h-32 mx-auto mb-6 rounded-full bg-gradient-to-br from-primary-500 to-secondary-400 flex items-center justify-center animate-float">
                    <span className="font-gaming text-5xl font-black">RB</span>
                  </div>
                  <p className="text-2xl font-gaming text-primary-500">EST. 2024</p>
                  <p className="text-gray-400 mt-2">Dar es Salaam, Tanzania</p>
                </div>
              </div>
            </div>

            {/* Floating decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary-500/20 rounded-full blur-xl animate-pulse-slow" />
            <div
              className="absolute -bottom-4 -left-4 w-32 h-32 bg-secondary-400/20 rounded-full blur-xl animate-pulse-slow"
              style={{ animationDelay: '1s' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
